module.exports = __webpack_public_path__ + "static/5-c591ae9850138378e0f7074e5dde4e13.jpg";